<template>
  <v-dialog v-if="item" v-model="dialog" max-width="1300">
    <v-row :no-gutters="mobile">
      <v-col
        cols="12"
        md="2"
        :class="{
          'pr-0': !mobile,
          'pb-7': !mobile,
          'pa-0': mobile,
          'pb-0': mobile
        }"
      >
        <v-card
          :class="{
            'pt-2': true,
            'card-check-behind': true,
            'pa-4': !mobile,
            'px-6': !mobile,
            'px-4': mobile,
            'pb-0': mobile,
            'd-flex': true,
            'flex-column': true,
            'justify-space-around': !mobile,
            'rounded-bl-0': mobile,
            'rounded-br-0': mobile
          }"
          :elevation="!mobile ? 8 : 0"
        >
          <div>
            <p class="caption">Sequence #</p>
            <p>
              <b>{{ item.refNo }}</b>
            </p>
          </div>
          <v-radio-group
            v-model="item.category"
            mandatory
            hide-details
            class="mt-0"
          >
            <template v-slot:label>
              <p class="caption">Payment Category:</p>
            </template>
            <p class="font-weight-bold">Rental</p>
          </v-radio-group>

          <div>
            <p :class="{ caption: true, 'mt-1': mobile }">
              Valid for the period:
            </p>
            <p>
              <strong>{{ getStartDateFromDue(item.dueDate) || 'x' }}</strong>
            </p>
            <p :class="{ caption: true, 'mt-2': !mobile, 'mt-1': mobile }">
              until:
            </p>
            <p>
              <strong>{{ getEndDateFromDue(item.dueDate) || 'x' }}</strong>
            </p>
          </div>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="10"
        :class="{
          'pl-0': !mobile,
          'pa-0': mobile
        }"
      >
        <v-card
          :class="{
            'mb-4': true,
            'px-4': !mobile,
            'pl-8': !mobile,
            'pb-2': !mobile,
            'pt-2': !mobile,
            'rounded-tl-0': mobile,
            'rounded-tr-0': mobile,
            'card-check': true
          }"
          :elevation="!mobile ? 8 : 0"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="3"
                :class="{ 'pr-1': !mobile, 'py-0': true }"
              >
                <v-text-field
                  outlined
                  dense
                  hint="Tenant *"
                  persistent-hint
                  readonly
                  :value="item.tenantName"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="3"
                :class="{ 'pr-1': !mobile, 'py-0': true }"
              >
                <v-text-field
                  outlined
                  dense
                  hint="Unit *"
                  persistent-hint
                  readonly
                  :value="getUnitName()"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="2"
                :class="{ 'pr-1': !mobile, 'py-0': true }"
              >
                <v-text-field
                  v-model="item.routingNumber"
                  solo
                  flat
                  dense
                  hint="Routing Number"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="2"
                :class="{ 'pr-1': !mobile, 'py-0': true }"
              >
                <v-text-field
                  v-model="item.accountNumber"
                  solo
                  flat
                  dense
                  hint="Account Number *"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="2"
                :class="{ 'pr-1': !mobile, 'py-0': true }"
              >
                <v-text-field
                  v-model="item.checkNumber"
                  solo
                  flat
                  dense
                  hint="Check Number *"
                  persistent-hint
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="9"
                :class="{ 'pr-1': !mobile, 'pb-0': true }"
              >
                <v-text-field
                  dense
                  label="Pay to the order of"
                  :placeholder="property.propertyName"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="3"
                :class="{ 'pr-1': !mobile, 'pb-0': true }"
              >
                <v-menu
                  v-model="checkDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      solo
                      flat
                      dense
                      readonly
                      hint="Check Date *"
                      persistent-hint
                      :value="getDueDate(item.checkDate)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon small class="mt-1">mdi-calendar-month</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="item.checkDate"
                    no-title
                    scrollable
                    @input="checkDateMenu = false"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="8"
                :class="{ 'pr-1': !mobile, 'pt-0': true }"
              >
                <v-textarea
                  v-model="item.description"
                  solo
                  flat
                  dense
                  hint="Description"
                  persistent-hint
                  rows="1"
                  auto-grow
                ></v-textarea>
              </v-col>
              <v-col
                cols="12"
                md="4"
                :class="{ 'pr-1': !mobile, 'pt-0': true }"
              >
                <v-currency-field
                  outlined
                  dense
                  hint="Amount (Rent Fee) *"
                  persistent-hint
                  readonly
                  :value="item.amount"
                  disabled
                ></v-currency-field>
              </v-col>
              <!-- <v-col cols="12" md="3" :class="{'pr-1': !mobile, 'py-0': true}">
                <v-text-field solo flat dense label="Attachments"></v-text-field>
              </v-col> -->
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="4"
                :class="{ 'pr-1': !mobile, 'py-0': true }"
              >
                <v-text-field
                  v-model="item.bank"
                  solo
                  flat
                  dense
                  hint="Bank / Branch *"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="3"
                :class="{ 'pr-1': !mobile, 'py-0': true }"
              >
              </v-col>
              <v-col
                cols="12"
                md="5"
                :class="{
                  'pr-1': !mobile,
                  'py-0': true,
                  'd-flex': true,
                  'flex-column': true,
                  'justify-end': !mobile
                }"
              >
                <v-row>
                  <v-col cols="12" class="py-0">
                    <v-file-input
                      ref="file"
                      v-model="attachments"
                      accept="image/*, application/pdf"
                      label="Upload Attachments"
                      prepend-icon=""
                      chips
                      small-chips
                      multiple
                      dense
                      outlined
                      hide-details
                    >
                      <template v-slot:prepend-inner>
                        <v-icon small class="mt-1">mdi-paperclip</v-icon>
                      </template>
                    </v-file-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="py-0">
                    <v-chip-group v-if="item.attachments.length">
                      <v-chip
                        v-for="attachment in item.attachments"
                        :key="attachment.url"
                        close
                        @click="downloadAttachment(attachment)"
                        >{{ attachment.shortFilename }}</v-chip
                      >
                    </v-chip-group>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-card-actions
              :class="{ 'px-0': mobile, 'my-4': mobile, 'mb-0': !mobile }"
            >
              <v-spacer v-if="!mobile"></v-spacer>
              <v-btn depressed @click="dialog = false">Close</v-btn>
              <v-spacer v-if="mobile"></v-spacer>
              <v-btn depressed color="primary" @click="finish">Update</v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
import { dayjs } from '../../util/date'
import { truncateString } from '../../config/string'

export default {
  // props: ['item', 'property'],
  data() {
    return {
      item: null,
      dialog: false,
      checkDateMenu: false,
      attachments: []
    }
  },
  computed: {
    units() {
      return this.$store.getters['units/getUnitsFlat']
    },
    property() {
      return this.$store.getters['properties/getProperty']
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  methods: {
    open(params) {
      this.item = JSON.parse(JSON.stringify(params.item))
      this.item.attachments =
        (this.item.attachments &&
          this.item.attachments.map((attachment) => {
            if (attachment)
              attachment.shortFilename = truncateString(attachment.filename, 12)
            return attachment
          })) ||
        []
      this.item.checkDate = dayjs(this.item.dueDate).format('YYYY-MM-DD')
      this.checkDateMenu = false
      this.attachments = []

      this.dialog = true

      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    downloadAttachment(attachment) {
      window.open(attachment.url)
    },
    getDueDate(date) {
      return dayjs(date).format('MMMM DD, YYYY')
    },
    getStartDateFromDue(date) {
      return dayjs(date).format('MMMM DD, YYYY')
    },
    getEndDateFromDue(date) {
      return dayjs(date)
        .add(1, 'month')
        .subtract(1, 'day')
        .format('MMMM DD, YYYY')
    },
    getUnitName() {
      const unit = this.units.find((u) => u.bedId === parseInt(this.item.bedId))
      return unit && unit.bedName
    },
    async finish() {
      if (
        await this.$root.$confirm({
          title: 'Update PDC',
          message:
            'Are you sure you would like to update the post dated checks?'
        })
      ) {
        this.$root.$setLoading(true)
        await this.$store.dispatch('pdcs/updatePDCAction', {
          pdcId: this.item.pdcId,
          bank: this.item.bank,
          routingNumber: this.item.routingNumber,
          accountNumber: this.item.accountNumber,
          checkNumber: this.item.checkNumber,
          description: this.item.description,
          dueDate: dayjs(this.item.checkDate).format(),
          attachments: this.attachments
        })

        await this.$root
          .$confirm({
            title: 'Update PDC',
            message: `The Post Dated Checks have been updated.`,
            reconfirmOnly: true,
            confirmText: 'OK',
            options: {
              color: 'success'
            }
          })
          .then(() => {
            this.$root.$setLoading(false)
            this.dialog = false
            this.resolve(true)
          })
      }
    }
  }
}
</script>

<style scoped>
.v-card.card-check {
  background-color: #ecebea;
}
.v-card.card-check-behind {
  background-color: #f1f2ee;
  height: 100%;
  z-index: 4;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.v-card.card-check-behind:after {
  top: 0;
  left: -10px;
  content: '';
  width: 10px;
  height: 100%;
  position: absolute;
  background-color: #ffffff;
  background: linear-gradient(-137deg, #f1f2ee 6px, transparent 0) 0 5px,
    linear-gradient(320deg, #f1f2ee 6px, transparent 0) 0 5px;
  background-position: left;
  background-repeat: repeat-y;
  background-size: 10px 10px;
}

.v-card.card-check-behind:after {
  left: auto;
  right: -10px;
  top: 0;
  transform: scaleX(-1);
}
.test {
  border: 2px solid yellow;
}
</style>
